import React from "react";
import {
  Avatar,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Tooltip,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import moment from "moment";
import "moment/locale/pt";

moment.locale("pt");

const DashboardLastMagazinesList = ({ magazines }) => {
  return (
    <Card>
      <CardHeader title={"Últimas revistas"} />
      <CardContent sx={{ pt: 2 }}>
        <Stack direction={"column"} width={"100%"} gap={2}>
          <List
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          >
            {magazines.length > 0 ? (
              magazines.map((magazine) => (
                <ListItem
                  secondaryAction={
                    <IconButton edge="end" aria-label="delete">
                      <Tooltip
                        title="Baixar"
                        onClick={() => {
                          window.open(magazine.linkPdf, "_blank");
                        }}
                      >
                        <PictureAsPdfIcon color="error" />
                      </Tooltip>
                    </IconButton>
                  }
                >
                  <ListItemAvatar>
                    <Avatar
                      sx={{
                        background: "#319795",
                      }}
                    >
                      <DescriptionIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={`RPI ${magazine?.numeroRevista || 'N/A'}`}
                    secondary={magazine?.dataRevista 
                      ? moment.utc(magazine.dataRevista).format("DD [de] MMMM [de] YYYY")
                      : 'Data não disponível'
                    }
                  />
                </ListItem>
              ))
            ) : (
              <ListItem>
                <ListItemText>Nenhum dado disponível</ListItemText>
              </ListItem>
            )}
          </List>
        </Stack>
      </CardContent>
      <CardActionArea>
        <Button
          fullWidth
          variant="contained"
          color="info"
          onClick={() => {
            window.open("https://revistas.inpi.gov.br/rpi/", "_blank");
          }}
        >
          Acessar site do INPI
        </Button>
      </CardActionArea>
    </Card>
  );
};

export default React.memo(DashboardLastMagazinesList);
